import { count } from 'pages/admin/shared/formatters';
import type { TopArgument } from './types';
import styles from './page.module.scss';

interface TopArgumentsCellProps {
  topArguments: TopArgument[];
}

/**
 * The most common values of each leading argument of a job class, e.g.
 * `arg 0 (2 distinct): DevelopmentArea × 40,123, Well × 1,204`. A "+" on the
 * distinct count means the scan stopped tracking new values for that argument.
 *
 * @param {TopArgumentsCellProps} props - The per-position argument tallies.
 * @return The cell content.
 */
export function TopArgumentsCell({ topArguments }: TopArgumentsCellProps) {
  if (topArguments.length === 0) return <span>—</span>;

  return (
    <ul className={styles.argumentList}>
      {topArguments.map((argument) => (
        <li key={argument.position} className={styles.argumentItem}>
          <span className={styles.argumentPosition}>
            arg {argument.position} ({count(argument.distinctCount)}
            {argument.distinctCapped ? '+' : ''} distinct):
          </span>{' '}
          {argument.topValues
            .map((topValue) => `${topValue.value} × ${count(topValue.count)}`)
            .join(', ')}
        </li>
      ))}
    </ul>
  );
}
